<template>
  <div class="menuFrame">
    <loading :active.sync="isLoading"></loading>
    <div>
      <div id="track">
        <div class="d-flex justify-content-between">
          <div>
            <a href="/ExhibitorServiceTW/">展覽列表</a><span>/</span
            ><em name="Exhibition"></em><span>/</span
            ><span class="px-0">大會活動</span><span>/</span
            ><span
              @click.prevent="toEventMain"
              style="color: #1a73e8"
              class="pointer px-0"
              >test</span
            ><span>/</span><a href="javascript:history.back()">選擇推廣產品</a
            ><span>/</span>建立推廣產品介紹
          </div>
          <div>
            <span class="bold">登入帳號 :</span>
            <span> {{ UserId }}</span>
          </div>
        </div>
      </div>
      <!-- track end -->
      <!-- article -->
      <article>
        <div class="contentBox">
          <div class="container">
            <h1>新增線上活動贈品贊助</h1>
            <p class="my-3">&nbsp;</p>
            <p class="alert">
              <i class="fas fa-exclamation-circle"></i>
              請勿上傳與本展無關或是妨害社會善良風俗之內容，主辦單位有權刪除不適當的內容。
            </p>
            <p class="my-3">&nbsp;</p>

            <form id="form" @submit.prevent="AddPromotionPro">
              <input type="hidden" name="RegNo" />

              <p class="formTitle">活動名稱</p>
              <p>
                {{ EventDetail.EventName }}
              </p>

              <p class="my-3">&nbsp;</p>

              <p class="formTitle">產品名稱 <span class="red">*</span></p>
              <div class="langTip">
                <input
                  type="text"
                  name="ProName"
                  class="textStyle maxText"
                  maxlength="200"
                  required
                  placeholder="中文"
                  v-model="ProName"
                />
                <span>中</span>
              </div>

              <p class="clear"></p>
              <p class="my-3">&nbsp;</p>

              <div class="left">
                <p class="formTitle">產品簡介 <span class="red">*</span></p>
                <div class="langTip">
                  <input
                    type="text"
                    name="ProDesc"
                    class="textStyle maxText"
                    maxlength="200"
                    required
                    placeholder="中文"
                    v-model="ProDesc"
                  />
                  <span>中</span>
                </div>
              </div>

              <div class="right">
                <p class="formTitle">規格 <span class="red">*</span></p>
                <div class="langTip">
                  <input
                    type="text"
                    name="ProSpec"
                    class="textStyle maxText"
                    maxlength="200"
                    required
                    placeholder="中文"
                    v-model="ProSpec"
                  />
                  <span>中</span>
                </div>
              </div>

              <p class="my-3">&nbsp;</p>

              <div class="left">
                <p class="formTitle">提供數量</p>
                <div>
                  <input
                    type="number"
                    name="ProvidedCount"
                    class="maxText textStyle"
                    maxlength="20"
                    v-model="ProvidedCount"
                  />
                </div>
              </div>

              <div class="right">
                <p class="formTitle">市價(NT$)</p>
                <div>
                  <input
                    type="text"
                    name="ProPrice"
                    class="maxText textStyle"
                    maxlength="20"
                    v-model="ProPrice"
                  />
                </div>
              </div>

              <p class="my-3">&nbsp;</p>

              <!-- <h2>贊助商logo</h2>

              <p class="my-3">&nbsp;</p> -->

              <div class="left">
                <p class="formTitle">現場聯絡人姓名</p>
                <div>
                  <input
                    type="text"
                    name="ContactName"
                    class="maxText textStyle"
                    maxlength="20"
                    v-model="ContactName"
                  />
                </div>
              </div>

              <div class="right">
                <p class="formTitle">現場聯絡人手機</p>
                <div>
                  <input
                    type="text"
                    name="ContactMobile"
                    class="maxText textStyle"
                    maxlength="20"
                    v-model="ContactMobile"
                  />
                </div>
              </div>
              <p class="my-3">&nbsp;</p>

              <div class="left">
                <p class="formTitle">產品網站</p>
                <div>
                  <input
                    type="text"
                    name="ProUrl"
                    class="maxText textStyle"
                    maxlength="20"
                    v-model="ProUrl"
                  />
                </div>
              </div>

              <div class="right">
                <p class="formTitle">產品類別 <span class="red">*</span></p>
                <div class="form-row">
                  <div class="form-group col-md-4">
                    <select
                      class="form-control text-dark"
                      v-model="CatID"
                      required
                    >
                      <option value="">-- 請選擇 --</option>
                      <option
                        v-for="item in EventsCategories"
                        :value="item.CatID"
                        :key="item.CatID"
                      >
                        {{ item.CatName }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>

              <p class="my-3">&nbsp;</p>

              <!-- <p class="formTitle">贊助商社群連結</p>
              <div>
                <input
                  type="text"
                  name="ProPrice"
                  class="maxText textStyle"
                  maxlength="20"
                  v-model="ProPrice"
                />
              </div>
              <p class="my-3">&nbsp;</p> -->

              <div v-if="LocalExh">
                <p class="my-3">&nbsp;</p>
                <p class="formTitle">
                  宣傳貼文文案 (中) <span class="red">*</span>
                </p>
                <textarea
                  name="PromoPostText"
                  rows="6"
                  class="maxText textStyle"
                  placeholder="中文"
                  v-model="PromoPostText"
                  required
                ></textarea>
              </div>

              <p class="my-3">&nbsp;</p>

              <!-- <div v-if="inputDescHidden == 0">
                <p class="formTitle mt-2">
                  {{ inputDescName }}
                  <span class="red" v-if="inputDescRequired == 0">*</span>
                </p>
                <div v-if="LocalExh">
                  <div class="langTip">
                    <input
                      type="text"
                      name="Desc"
                      class="maxText textStyle"
                      :required="inputDescRequired == 0"
                      maxlength="20"
                      v-model="reg_Desc"
                    />
                    <span>中 </span>
                  </div>
                  <div class="blueBG mt-1" v-if="inputDescNotes">
                    {{ inputDescNotes }}
                  </div>
                </div>
                <div v-if="einputDescName">
                  <div class="langTip mt-2">
                    <input
                      type="text"
                      name="Desc"
                      class="maxText textStyle"
                      :required="inputDescRequired == 0"
                      maxlength="50"
                      v-model="ereg_Desc"
                    />
                    <span>英 </span>
                  </div>
                  <div class="blueBG mt-1" v-if="einputDescNotes">
                    {{ einputDescNotes }}
                  </div>
                </div>

                <p class="my-3">&nbsp;</p>
              </div>

              <div class="mt-3" v-if="inputDescHidden2 == 0">
                <p class="formTitle">
                  {{ inputDescName2 }}
                  <span class="red" v-if="inputDescRequired2 == 0">*</span>
                </p>
                <div v-if="LocalExh">
                  <div class="langTip">
                    <input
                      type="text"
                      name="Desc2"
                      class="maxText textStyle"
                      :required="inputDescRequired2 == 0"
                      maxlength="20"
                      v-model="reg_Desc2"
                    />
                    <span>中 </span>
                  </div>
                  <div class="blueBG mt-1" v-if="inputDescNotes2">
                    {{ inputDescNotes2 }}
                  </div>
                </div>
                <div v-if="einputDescName">
                  <div class="langTip mt-2">
                    <input
                      type="text"
                      name="Desc2"
                      class="maxText textStyle"
                      :required="inputDescRequired2 == 0"
                      maxlength="50"
                      v-model="ereg_Desc2"
                    />
                    <span>英 </span>
                  </div>
                  <div class="blueBG mt-1" v-if="einputDescNotes2">
                    {{ einputDescNotes2 }}
                  </div>
                </div>

                <p class="my-3">&nbsp;</p>
              </div>

              <span v-if="inputOnlineDateHidden == 0">
                <p class="formTitle mt-3">
                  上市時間
                  <span class="red" v-if="inputOnlineDateRequired == 0">*</span>
                </p>
                <div>
                  <input
                    type="text"
                    name="LaunchDate"
                    class="maxText textStyle"
                    :required="inputOnlineDateRequired == 0"
                    maxlength="20"
                    v-model="reg_LaunchDate"
                  />
                </div>
                <p class="my-3">&nbsp;</p>
              </span>

              <span v-if="inputPriceHidden == 0">
                <p class="formTitle">
                  市價(NT$)
                  <span class="red" v-if="inputPriceRequired == 0">*</span>
                </p>
                <div>
                  <input
                    type="text"
                    name="Price"
                    class="maxText textStyle"
                    :required="inputPriceRequired == 0"
                    maxlength="20"
                    v-model="reg_Price"
                  />
                </div>
                <p class="my-3">&nbsp;</p>
              </span>

              <span v-if="inputDiscountPriceHidden == 0">
                <p class="formTitle">
                  展場限定價(NT$)
                  <span class="red" v-if="inputDiscountPriceRequired == 0"
                    >*</span
                  >
                </p>
                <div>
                  <input
                    type="text"
                    name="Discount"
                    class="maxText textStyle"
                    :required="inputDiscountPriceRequired == 0"
                    maxlength="20"
                    v-model="reg_DiscountPrice"
                  />
                </div>
                <p class="my-3">&nbsp;</p>
              </span> -->
              <div class="d-flex justify-content-center">
                <input type="submit" value="確定送出" class="btnStyle mr-4" />
                <div class="btnStyle btnGray" @click.prevent="backSelectPro">
                  返回
                </div>
              </div>
            </form>
          </div>
        </div>
      </article>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import axios from "axios";

export default {
  metaInfo() {
    return {
      title: "建立推廣產品介紹 - 展昭參展商管理系統",
    };
  },

  data() {
    return {
      LocalExh: true,
      UserId: "",
      RegNo: "",
      CSRF_Token: "",
      lang: "tw",
      EventDetail: {},
      MarketingRegisterList: [],
      ProductID: "",
      ProductDetail: {},
      reg_Desc: "",
      reg_Desc2: "",
      ereg_Desc: "",
      ereg_Desc2: "",
      reg_LaunchDate: "",
      reg_Price: "",
      reg_DiscountPrice: "",
      EventDetail: {},
      EventCatList: [],
      CatID: "",
      eventId: "",
      inputDescHidden: "",
      inputOnlineDateHidden: "",
      inputPriceHidden: "",
      inputDiscountPriceHidden: "",
      inputDescName: "",
      EventName: "",

      einputDescName: "",
      einputDescName2: "",
      einputDescNotes: "",
      einputDescNotes2: "",

      inputDescRequired: "",
      inputDescNotes: "",
      inputDescName2: "",
      inputDescHidden2: "",
      inputDescRequired2: "",
      inputDescNotes2: "",
      inputOnlineDateRequired: "",
      inputPriceRequired: "",
      inputDiscountPriceRequired: "",
      EventsCategories: [],
      ProvidedCount: 0,
      ProName: "",
      ProDesc: "",
      ProSpec: "",
      ProPrice: "",
      ContactName: "",
      ContactMobile: "",
      ProUrl: "",
      PromoPostText: "",
    };
  },

  watch: {},

  methods: {
    toEventMain() {
      const vm = this;
      document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/promotion?eventId=${vm.eventId}&no=${vm.RegNo}`;
    },
    AddPromotionPro() {
      const vm = this;
      const url = "/apiExhibitors/MarketingEventRegister/";

      const info = {
        regNo: vm.RegNo,
        eventId: vm.eventId,
        proNo: vm.ProductID,
        CatID: vm.CatID,
        reg_Desc: vm.reg_Desc,
        reg_Desc2: vm.reg_Desc2,
        ereg_Desc: vm.ereg_Desc,
        ereg_Desc2: vm.ereg_Desc2,

        reg_LaunchDate: vm.reg_LaunchDate,
        reg_Price: vm.reg_Price,
        reg_DiscountPrice: vm.reg_DiscountPrice,
        CSRF: vm.CSRF_Token,
      };

      // console.log(info)

      axios.post(url, info).then(function (response) {
        if (response.data.Code == 200) {
          alert("您已成功上傳！");
          document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/promotion?eventId=${vm.eventId}&no=${vm.RegNo}`;
        } else if (response.data.Code == 500) {
          alert("系統忙碌，請稍後再試！");
          document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/promotion?eventId=${vm.eventId}&no=${vm.RegNo}`;
        } else if (response.data.Code == 252) {
          document.location.href = `https://www.chanchao.com.tw/`;
        } else if (response.data.Code == 253) {
          alert("報名活動與報名表序號的參展代碼不一致！");
          // document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/promotion?eventId=${vm.eventId}&no=${vm.RegNo}`
        } else if (response.data.Code == 254) {
          alert("報名表序號與報名產品為不同參展商！");
          // document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/promotion?eventId=${vm.eventId}&no=${vm.RegNo}`
        } else if (response.data.Code == 255) {
          alert("報名時間超過活動的參展商系統上下線時間！");
          // document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/promotion?eventId=${vm.eventId}&no=${vm.RegNo}`
        } else if (response.data.Code == 256) {
          alert("廠商報名表的報名攤位數小於活動的限制攤位數！");
          // document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/promotion?eventId=${vm.eventId}&no=${vm.RegNo}`
        } else if (response.data.Code == 257) {
          alert("廠商已報名數量大於活動的限制報名數量！");
          // document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/promotion?eventId=${vm.eventId}&no=${vm.RegNo}`
        } else if (response.data.Code == 258) {
          alert("選取之產品已報名過活動！");
          // document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/promotion?eventId=${vm.eventId}&no=${vm.RegNo}`
        }
      });
    },

    backSelectPro() {
      const vm = this;
      document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/promotionSelectPro?no=${vm.RegNo}&eventId=${vm.eventId}`;
    },
  },

  computed: {},

  created() {
    const vm = this;

    //CSRF_Token
    axios
      .get("https://www.chanchao.com.tw/apiExhibitors/CSRF_Token")
      .then((response) => {
        vm.CSRF_Token = response.data;
      });

    axios
      .get(`https://www.chanchao.com.tw/apiExhibitors/UserID`)
      .then((response) => {
        vm.UserId = response.data;
      });

    //url取出展碼
    let currentUrl = location.href;
    vm.RegNo = currentUrl.split("no=")[1].split("&")[0];
    vm.ProductID = currentUrl.split("id=")[1].split("&")[0];
    vm.eventId = currentUrl.split("eventId=")[1];
    vm.type = currentUrl.split("type=")[1];

    let url = `/apiExhibitors/Product/${vm.RegNo}/${vm.ProductID}`;
    axios.get(url).then(function (response) {
      // console.log(response.data.Data)
      vm.ProductDetail = response.data.Data;
    });

    axios
      .get(
        `https://www.chanchao.com.tw/apiExhibitors/Exhibition/${vm.RegNo}?lang=${vm.lang}`,
      )
      .then((response) => {
        let ExpoLocation = response.data.Data.ExpoLocation;

        if (ExpoLocation === "T" || ExpoLocation === null) {
          vm.LocalExh = true;
        } else {
          vm.LocalExh = false;
        }
      });

    //取得總資料
    axios
      .get(
        `https://www.chanchao.com.tw/ApiMarketingCampaign/MarketingEvents/Detail/${vm.eventId}?type=${vm.type}&lang=tw`,
      )
      .then((response) => {
        // console.log(response.data.Data)

        vm.EventDetail = response.data.Data;

        // 欄位顯示判定

        // 開啟時間判定
        // let OpenRegiterDate = response.data.Data.backEndStartDate;
        // let CloseRegiterDate = response.data.Data.backEndEndDate;
        // let Nowdate = Date.parse(new Date()).valueOf();

        // if (Nowdate < OpenRegiterDate) {
        //   alert("活動尚未開放");
        //   document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/promotion?eventId=${vm.eventId}&no=${vm.RegNo}`;
        // } else if (Nowdate > CloseRegiterDate) {
        //   alert("活動尚未開放");
        //   document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/promotion?eventId=${vm.eventId}&no=${vm.RegNo}`;
        // }
      });
    axios
      .get(
        `https://www.chanchao.com.tw/MarketingEvents/Categories/${vm.eventId}?type=${vm.type}&lang=tw`,
      )
      .then((response) => {
        vm.EventsCategories = response.data.Data;
      });
  },
};
</script>

<style lang="scss"></style>
